<template>
    <div class="row">
        <div class="col-12">
            <div class="text-center mb-3">
                <p class="h4">
                    {{ $t("gracias.descargar_entradas") }}
                </p>
            </div>
            <div class="col-12" v-for="pedido in datos_pack.pedidos" :key="pedido.id">
                <div class="row">
                    <div class="col-12 mt-3">
                        <div class="h4" style="text-transform: uppercase">
                            {{ pedido.evento.name }}:
                        </div>
                    </div>
                    <div class="col-12">
                        <template v-for="(entrada, i) in pedido.entradas">
                            <TarjetaEntrada
                                v-bind:key="i"
                                :entrada="entrada"
                                :index="i"
                            />
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TarjetaEntrada from './components/TarjetaEntrada.vue';

    export default {
        props: {
            datos_pack: {
                required: true,
                type: Object
            }
        },
        components: {
            TarjetaEntrada
        }
    }
</script>